
interface CardProps {
  children: React.ReactNode;
  className?: string;
  title?: string;
  padding?: boolean;
}

export default function Card({ 
  children, 
  className = '', 
  title,
  padding = true 
}: CardProps) {
  return (
    <div className={`bg-white rounded-lg shadow-md border border-gray-200 ${className}`}>
      {title && (
        <div className="px-6 py-4 border-b border-gray-200">
          <h3 className="text-lg font-semibold text-gray-900">{title}</h3>
        </div>
      )}
      <div className={padding ? 'p-6' : ''}>
        {children}
      </div>
    </div>
  );
}
